import KeenSlider from "keen-slider";

export function initHistorySlider() {
  const container = document.querySelector("[data-history-slider]");
  if (!container) return;

  const track = container.querySelector("[data-history-slider-track]");
  const slides = track.querySelectorAll(".keen-slider__slide");
  const prev = container.querySelector("[data-history-prev]");
  const next = container.querySelector("[data-history-next]");

  const slider = new KeenSlider(track, {
    loop: false,
    mode: "snap",
    renderMode: "performance",
    slides: {
      perView: "auto",
      spacing: 60,
      origin: "center",
    },
    created(s) {
      updateScale(s);
      updateNav(s);
    },
    slideChanged(s) {
      updateScale(s);
      updateNav(s);
    },
  });

  function updateScale(s) {
    const rel = s.track.details.rel;

    slides.forEach((slide, index) => {
      const distance = Math.abs(index - rel);

      if (distance === 0) {
        slide.style.zIndex = "3";
        slide.classList.remove("is-disabled");
      } else if (distance === 1) {
        slide.style.zIndex = "2";
        slide.classList.add("is-disabled");
      } else {
        slide.style.zIndex = "1";
        slide.classList.add("is-disabled");
      }
    });
  }

  function updateNav(s) {
    const rel = s.track.details.rel;
    const max = s.track.details.maxIdx;

    prev?.classList.toggle("is-disabled", rel === 0);
    next?.classList.toggle("is-disabled", rel === max);
  }

  prev?.addEventListener("click", () => slider.prev());
  next?.addEventListener("click", () => slider.next());
}
